/* template */
import BookInfo from "../components/template/InfoBookTemplate"

const InfoBook = () => {
  return (
   <BookInfo />
  )
}

export default InfoBook